<style scoped lang="less" rel="stylesheet/less" scoped>
	.back-bg{
        height: 50px;
        width: 62px;
        position: fixed;
        z-index: 30;
        left: 30px;
        top:15px;
        background: url(../../assets/img/common/arrow_left.png) no-repeat;
        background-size: cover;
        &:hover{
            background: url(../../assets/img/common/arrow_left3.png) no-repeat;
            background-size: cover;
        }
    }
</style>
<template>
<div class="back-bg cursor" @click="goBackEvent">
</div>
</template>

<script>
	export default {
        methods:{
            goBackEvent(){
                this.$emit('goBack')
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/basic/back.vue